
import { useToggle } from '@vueuse/core'
import { useConfirm } from 'primevue/useconfirm'
import { computed, defineComponent, PropType, toRefs } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useCollection, useDocument } from '../../composables'
export default defineComponent({
  name: 'DocumentPage',
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String as PropType<string | undefined>,
      default: undefined
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    onBeforeRouteUpdate(() => {
      // TODO Confirm leaving if changes in the form
    })
    onBeforeRouteLeave(() => {
      // TODO Confirm leaving if changes in the form
    })
    const [visibleInfo, toggleInfo] = useToggle()
    // TODO allow creating a new document
    const router = useRouter()
    const { id, name } = toRefs(props)
    const collection = useCollection(name)
    const properties = computed(() => collection.value?.properties)
    const document = useDocument(collection, id)

    const store = useStore()
    const form = computed(() => store.getters['rxdb/form'])
    const read = () =>
      document.value &&
      router.replace({
        name: 'document',
        params: {
          collection: props.name,
          id: document.value.primary
        }
      })

    const edit = () =>
      props.id &&
      router.replace({
        name: 'document',
        params: {
          collection: props.name,
          id: props.id,
          action: 'edit'
        }
      })
    const save = async () => {
      await store.dispatch('rxdb/save')
      read()
    }
    const reset = () => {
      store.commit('rxdb/reset')
    }
    const cancel = () => {
      reset()
      if (props.id) read()
      else router.go(-1)
    }
    const confirm = useConfirm()
    const remove = () => {
      confirm.require({
        message: 'Are you sure you want to remove this document?',
        header: 'Confirmation',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-danger',
        accept: async () => {
          await document.value?.remove()
          router.go(-1)
        },
        reject: () => {
          //callback to execute when user rejects the action
        }
      })
    }

    return {
      visibleInfo,
      toggleInfo,
      form,
      collection,
      properties,
      save,
      reset,
      cancel,
      remove,
      confirm,
      edit,
      document
    }
  }
})
